export const AUTHENTICATED_REQUEST = 'AUTHENTICATED_REQUEST';

export default {
    authenticatedRequest: (request) => ({type: AUTHENTICATED_REQUEST, request})
}